<div [id]="blogContainerId" class="dinings-page-container">
  <app-small-header textColor="#fff" [homePage]="true"></app-small-header>
  <div class="hero-section">
    <div class="overlay"></div>
    <div class="logo-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="420"
        height="160"
        viewBox="0 0 489.221 198.427"
      >
        <g
          id="Group_17"
          data-name="Group 17"
          transform="translate(666.454 -505.208)"
        >
          <path
            id="Path_49091"
            data-name="Path 49091"
            d="M182.06,121.694q-13.847-7.839-29.592-25.257L105.4,47.375,139.144,13.7q7.268-6.968,18.862-6.967h.692V5.425H119.069V6.732H120.8q3.459,0,4.845,2.177a3.9,3.9,0,0,1,.52,2.033,4.066,4.066,0,0,1-1.385,2.613L83.766,59.132l45.513,47.03q21.456,22.351,42.052,28.6a65.6,65.6,0,0,0,18.689,2.468q10.383,0,23.016-5.516l-.173-1.452a67.44,67.44,0,0,1-30.8-8.564"
            transform="translate(-705.399 502.686)"
            fill="#e99b10"
          />
          <path
            id="Path_49092"
            data-name="Path 49092"
            d="M50.359,105.582a11.914,11.914,0,0,1-7.787-2.686,8.085,8.085,0,0,1-3.288-6.459V15.877A7.891,7.891,0,0,1,42.571,9.49a12.132,12.132,0,0,1,7.787-2.613h2.077l.173-1.452H0V6.877H2.25A12.272,12.272,0,0,1,7.615,8.038q5.536,2.612,5.711,7.838V96.437A8.723,8.723,0,0,1,9.951,102.9a11.586,11.586,0,0,1-7.7,2.686H0v1.452H52.609l-.173-1.452Z"
            transform="translate(-666.454 502.686)"
            fill="#e99b10"
          />
          <path
            id="Path_49093"
            data-name="Path 49093"
            d="M334.553,87.563a31.293,31.293,0,0,1-11.248,8.128,38.248,38.248,0,0,1-15.229,2.831h-22.67V57.733h22.843a16.482,16.482,0,0,1,10.556,3.629,11.057,11.057,0,0,1,4.154,8.854v1.162h1.73V37.992h-1.73v1.016a11.26,11.26,0,0,1-4.154,8.927,16.235,16.235,0,0,1-10.556,3.7H285.406V9.4h30.838a18.464,18.464,0,0,1,10.435,4.064A13.434,13.434,0,0,1,331.438,24.2v1.742h1.731V.542A29.939,29.939,0,0,1,327.977,1.7q-3.634.582-7.874,1.016a78.891,78.891,0,0,1-8.047.435H246.123V4.606h2.25a11.6,11.6,0,0,1,7.7,2.686,8.733,8.733,0,0,1,3.374,6.459V94.167a8.724,8.724,0,0,1-3.374,6.459,11.587,11.587,0,0,1-7.7,2.686h-2.25v1.451h89.642l7.96-29.757h-1.73a40.7,40.7,0,0,1-7.441,12.556"
            transform="translate(-780.884 504.956)"
            fill="#e99b10"
          />
          <path
            id="Path_49094"
            data-name="Path 49094"
            d="M697.149,103.06a17.9,17.9,0,0,1-8.133-2.1,16.556,16.556,0,0,1-5.83-5.139L630.87,0h-1.558A12.3,12.3,0,0,1,628.1,4.427q-1.213,2.831-2.682,5.879t-2.769,5.443q-1.3,2.395-1.817,3.266l-40.4,76.667a15.676,15.676,0,0,1-5.894,5.273,22.47,22.47,0,0,1-2.685,1.123q-.439-.119-.863-.252a21.171,21.171,0,0,1-6.576-3.484,66,66,0,0,1-6.922-6.314q-2.426-2.613-5.365-6.1t-5.624-6.9q-2.686-3.409-4.5-5.733t-1.99-2.613a49.082,49.082,0,0,0-7.528-7.548,26.3,26.3,0,0,0-10.124-5.225q9.864-.872,16.094-5.153a27.476,27.476,0,0,0,9.258-10.306,26.774,26.774,0,0,0,3.029-12.121,22.9,22.9,0,0,0-3.461-12.918A25.867,25.867,0,0,0,538.027,9a45.309,45.309,0,0,0-13.239-4.645A79.471,79.471,0,0,0,509.56,2.9H450.2V4.354h2.249a11.6,11.6,0,0,1,7.7,2.686,8.731,8.731,0,0,1,3.375,6.459V93.915a8.723,8.723,0,0,1-3.375,6.459,11.586,11.586,0,0,1-7.7,2.686H450.2v1.451h52.435V103.06h-2.077a11.914,11.914,0,0,1-7.787-2.686,8.086,8.086,0,0,1-3.288-6.459V9.289h2.682q2.336,0,5.192-.072t5.278.072A21.746,21.746,0,0,1,516.828,14.3q5.711,4.865,6.229,15.314a17.449,17.449,0,0,1-.086,3.919,28.418,28.418,0,0,1-.606,3.048,20.454,20.454,0,0,1-4.845,10.016,20.385,20.385,0,0,1-7.874,5.225,26.472,26.472,0,0,1-9.085,1.6H495.2v1.452a13.3,13.3,0,0,1,6.489,2.758,19.057,19.057,0,0,1,5.278,6.968q.52,1.307,1.731,3.629t2.856,5.153q1.642,2.831,3.374,5.879t3.375,5.734a44.233,44.233,0,0,0,3.029,4.428,33.718,33.718,0,0,0,10.21,9,42.407,42.407,0,0,0,13.5,4.717A95.387,95.387,0,0,0,562,104.511h39.8V103.06H600.24a8.874,8.874,0,0,1-4.153-1.089,6.193,6.193,0,0,1-2.942-3.121,5.592,5.592,0,0,1,.294-4.421l9.128-18.368h40.616l8.5,17.854h-.044q2.076,4.355-.52,6.75a8.652,8.652,0,0,1-6.056,2.395H643.5v1.451h55.031V103.06ZM605.6,69.964l17.716-35.652,16.969,35.652Z"
            transform="translate(-875.767 505.208)"
            fill="#e99b10"
          />
          <rect
            id="Rectangle_144"
            data-name="Rectangle 144"
            width="479.977"
            height="1.935"
            transform="translate(-665.467 652.869)"
            fill="#aaa"
          />
          <path
            id="Path_49095"
            data-name="Path 49095"
            d="M10.273,341.443a9.3,9.3,0,0,1-3.959-3.126,7.937,7.937,0,0,1-1.44-4.724h5.489a4.953,4.953,0,0,0,1.6,3.33,5.659,5.659,0,0,0,3.981,1.3,6.137,6.137,0,0,0,4.139-1.281,4.169,4.169,0,0,0,1.485-3.307,3.615,3.615,0,0,0-.922-2.564,6.179,6.179,0,0,0-2.294-1.529,34.745,34.745,0,0,0-3.8-1.17,35.527,35.527,0,0,1-4.971-1.642,8.206,8.206,0,0,1-3.262-2.587,7.474,7.474,0,0,1-1.349-4.679,8.311,8.311,0,0,1,1.349-4.724,8.617,8.617,0,0,1,3.779-3.1,13.72,13.72,0,0,1,5.623-1.08,11.724,11.724,0,0,1,7.445,2.271,8.383,8.383,0,0,1,3.217,6.231H20.71a4.106,4.106,0,0,0-1.62-2.924,5.985,5.985,0,0,0-3.913-1.215,5.556,5.556,0,0,0-3.6,1.124,3.919,3.919,0,0,0-1.394,3.239,3.285,3.285,0,0,0,.877,2.362,6.2,6.2,0,0,0,2.227,1.462,34.535,34.535,0,0,0,3.689,1.17,38.6,38.6,0,0,1,5.061,1.71,8.431,8.431,0,0,1,3.329,2.632,7.568,7.568,0,0,1,1.372,4.746,8.53,8.53,0,0,1-1.283,4.5,9.246,9.246,0,0,1-3.734,3.4,12.312,12.312,0,0,1-5.781,1.283,13.994,13.994,0,0,1-5.669-1.1"
            transform="translate(-668.72 360.82)"
            fill="#aaa"
          />
          <path
            id="Path_49096"
            data-name="Path 49096"
            d="M94.642,325.127a8.43,8.43,0,0,1-3.6,3.442A13.359,13.359,0,0,1,84.7,329.9H79.031v12.687H73.9V311.315H84.7a13.637,13.637,0,0,1,6.1,1.238A8.612,8.612,0,0,1,94.53,315.9a9.187,9.187,0,0,1,1.237,4.724,9.447,9.447,0,0,1-1.125,4.5m-5.579-.742a4.855,4.855,0,0,0,1.439-3.757q0-5.129-5.8-5.129H79.031v10.212H84.7a6.255,6.255,0,0,0,4.364-1.327"
            transform="translate(-700.814 360.469)"
            fill="#aaa"
          />
          <path
            id="Path_49097"
            data-name="Path 49097"
            d="M157.991,336.155H144.9l-2.249,6.389H137.3l11.2-31.312h5.938l11.2,31.312h-5.4Zm-1.439-4.184-5.084-14.531-5.129,14.531Z"
            transform="translate(-730.288 360.508)"
            fill="#aaa"
          />
          <path
            id="Path_49098"
            data-name="Path 49098"
            d="M277.434,341.957l-3.869-3.869a15.152,15.152,0,0,1-4.9,3.351,15.355,15.355,0,0,1-5.939,1.1,14.064,14.064,0,0,1-5.893-1.17,8.985,8.985,0,0,1-3.959-3.352,9.188,9.188,0,0,1-1.394-5.061,9.593,9.593,0,0,1,1.844-5.781,12.285,12.285,0,0,1,5.489-4.026,11.127,11.127,0,0,1-1.844-2.947,8.222,8.222,0,0,1-.54-3.037,6.6,6.6,0,0,1,1.058-3.689,7.239,7.239,0,0,1,3.037-2.564,10.547,10.547,0,0,1,4.589-.944,9.377,9.377,0,0,1,4.521,1.012,6.626,6.626,0,0,1,2.789,2.767,7,7,0,0,1,.742,3.914h-5.129a3.52,3.52,0,0,0-.81-2.587,3.034,3.034,0,0,0-2.339-.922,3.349,3.349,0,0,0-2.407.878,2.839,2.839,0,0,0-.922,2.137,4.718,4.718,0,0,0,.7,2.407,19.292,19.292,0,0,0,2.452,3.081l8.278,8.233,3.194-5.263h5.533l-4.049,6.928-1.125,1.844,7.6,7.558Zm-7.243-7.243-8.278-8.323q-5.308,2.116-5.308,6.389a4.984,4.984,0,0,0,1.71,3.846,6.3,6.3,0,0,0,4.408,1.553,9.956,9.956,0,0,0,7.469-3.465"
            transform="translate(-783.373 361.093)"
            fill="#aaa"
          />
          <path
            id="Path_49099"
            data-name="Path 49099"
            d="M412.839,311.316l-9.267,31.267h-5.8L391.2,318.919l-6.973,23.664-5.758.045-8.863-31.312h5.444l6.478,25.463,7.018-25.463H394.3l6.523,25.329,6.524-25.329Z"
            transform="translate(-838.295 360.468)"
            fill="#aaa"
          />
          <path
            id="Path_49100"
            data-name="Path 49100"
            d="M480.253,315.416v9.178h10.8v4.184h-10.8v9.583H492.4v4.184H475.124V311.232H492.4v4.184Z"
            transform="translate(-887.354 360.507)"
            fill="#aaa"
          />
          <path
            id="Path_49101"
            data-name="Path 49101"
            d="M541.125,338.444H551.7v4.139H536V311.316h5.129Z"
            transform="translate(-915.655 360.468)"
            fill="#aaa"
          />
          <path
            id="Path_49102"
            data-name="Path 49102"
            d="M595.272,338.444h10.572v4.139h-15.7V311.316h5.129Z"
            transform="translate(-940.829 360.468)"
            fill="#aaa"
          />
          <path
            id="Path_49103"
            data-name="Path 49103"
            d="M669.977,342.543h-5.129l-15.431-23.349v23.349h-5.129V311.231h5.129l15.431,23.3v-23.3h5.129Z"
            transform="translate(-966.003 360.508)"
            fill="#aaa"
          />
          <path
            id="Path_49104"
            data-name="Path 49104"
            d="M726.854,315.416v9.178h10.8v4.184h-10.8v9.583H739v4.184H721.725V311.232H739v4.184Z"
            transform="translate(-1002.006 360.507)"
            fill="#aaa"
          />
          <path
            id="Path_49105"
            data-name="Path 49105"
            d="M786.567,341.443a9.3,9.3,0,0,1-3.958-3.126,7.937,7.937,0,0,1-1.44-4.724h5.489a4.955,4.955,0,0,0,1.6,3.33,5.661,5.661,0,0,0,3.982,1.3,6.138,6.138,0,0,0,4.139-1.281,4.168,4.168,0,0,0,1.484-3.307,3.614,3.614,0,0,0-.922-2.564,6.179,6.179,0,0,0-2.294-1.529,34.75,34.75,0,0,0-3.8-1.17,35.537,35.537,0,0,1-4.971-1.642,8.2,8.2,0,0,1-3.261-2.587,7.474,7.474,0,0,1-1.35-4.679,8.311,8.311,0,0,1,1.35-4.724,8.615,8.615,0,0,1,3.779-3.1,13.721,13.721,0,0,1,5.624-1.08,11.723,11.723,0,0,1,7.445,2.271,8.386,8.386,0,0,1,3.217,6.231H797a4.1,4.1,0,0,0-1.62-2.924,5.984,5.984,0,0,0-3.914-1.215,5.558,5.558,0,0,0-3.6,1.124,3.919,3.919,0,0,0-1.394,3.239,3.286,3.286,0,0,0,.878,2.362,6.185,6.185,0,0,0,2.227,1.462,34.518,34.518,0,0,0,3.689,1.17,38.574,38.574,0,0,1,5.061,1.71,8.432,8.432,0,0,1,3.329,2.632,7.567,7.567,0,0,1,1.372,4.746,8.53,8.53,0,0,1-1.282,4.5,9.251,9.251,0,0,1-3.734,3.4,12.308,12.308,0,0,1-5.78,1.283,14,14,0,0,1-5.669-1.1"
            transform="translate(-1029.643 360.82)"
            fill="#aaa"
          />
          <path
            id="Path_49106"
            data-name="Path 49106"
            d="M854.166,341.443a9.3,9.3,0,0,1-3.958-3.126,7.937,7.937,0,0,1-1.44-4.724h5.489a4.955,4.955,0,0,0,1.6,3.33,5.661,5.661,0,0,0,3.982,1.3,6.137,6.137,0,0,0,4.139-1.281,4.168,4.168,0,0,0,1.484-3.307,3.614,3.614,0,0,0-.922-2.564,6.179,6.179,0,0,0-2.294-1.529,34.741,34.741,0,0,0-3.8-1.17,35.537,35.537,0,0,1-4.971-1.642,8.2,8.2,0,0,1-3.261-2.587,7.474,7.474,0,0,1-1.35-4.679,8.311,8.311,0,0,1,1.35-4.724,8.615,8.615,0,0,1,3.779-3.1,13.721,13.721,0,0,1,5.624-1.08,11.724,11.724,0,0,1,7.445,2.271,8.387,8.387,0,0,1,3.217,6.231H864.6a4.1,4.1,0,0,0-1.62-2.924,5.984,5.984,0,0,0-3.914-1.215,5.558,5.558,0,0,0-3.6,1.124,3.919,3.919,0,0,0-1.394,3.239,3.286,3.286,0,0,0,.878,2.362,6.185,6.185,0,0,0,2.227,1.462,34.518,34.518,0,0,0,3.689,1.17,38.571,38.571,0,0,1,5.061,1.71,8.432,8.432,0,0,1,3.329,2.632,7.567,7.567,0,0,1,1.372,4.746,8.529,8.529,0,0,1-1.282,4.5,9.251,9.251,0,0,1-3.734,3.4,12.308,12.308,0,0,1-5.78,1.283,14,14,0,0,1-5.669-1.1"
            transform="translate(-1061.072 360.82)"
            fill="#aaa"
          />
        </g>
      </svg>
    </div>
    <div class="text-box">
      <div class="text-box-inner">
        <p class="main-heading">Rejuvenation in the Lap of the Himalayas</p>
        <p class="sub-heading">
          Step into a serene world of indulgence at <strong>Kera Spa by Udaan</strong>, where
          signature therapies and tranquil mountain surroundings create the
          perfect escape for relaxation, rejuvenation, and holistic wellbeing
          across our premium stays in Darjeeling, Gangtok, Pelling & Lachung.
        </p>
      </div>
    </div>
  </div>

  <div class="container pb-5">
    <div class="dinings-top-margin pb-5">
      <app-section-title
        [title]="'Short and Sweet Treats'"
        [subtitle]="'LITTLE MOMENTS OF PURE BLISS'"
      ></app-section-title>
      <app-wellness-card [spaInfo]="latestSpas[0]"></app-wellness-card>
    </div>

    <div class="spa-top-margin pb-5">
      <app-section-title
        [title]="'Blissfull Massage Therapies'"
        [subtitle]="'SOOTHE YOUR BODY, CALM YOUR SOUL'"
      ></app-section-title>
      <app-wellness-card [spaInfo]="latestSpas[1]"></app-wellness-card>
    </div>

    <div class="py-0 py-md-4"></div>
  </div>
</div>
